import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { NestedPageHeader } from '../../components/header/page.header';
import { TenantTeams } from '../../components/tenant/tenant-teams';
import { useBeaconRouter } from '../../route/route.hooks';
import { useActiveWorkspace } from '../../store/workspace/workspace.hooks';

const TenantTeamsPage = (): ReactElement => {
  const { i18n } = useTranslation();
  const workspace = useActiveWorkspace();
  const { builder } = useBeaconRouter();

  let pageName: string = i18n.t('common:teams');
  if (workspace?.tenant.name) {
    pageName = `${workspace.tenant.name} ${i18n.t('common:teams')}`;
  }

  return (
    <IonPage>
      <NestedPageHeader
        title={pageName}
        defaultBackRoute={builder.getAdminRoute()}
      />
      <IonContent>
        <TenantTeams />
      </IonContent>
    </IonPage>
  );
};

export { TenantTeamsPage };
